// extracted by mini-css-extract-plugin
export default {"base":"StripedBox_base__5P5bg","base--color-red":"StripedBox_base--color-red__sb3da","base--color-green":"StripedBox_base--color-green__MZ3Nb"};